import EntityListCard from '@repo/ui/components/cards/EntityListCard';
import { useState } from 'react';
import { Unit, useCreateUnit, useDeleteUnit, useUnits, useUpdateUnit } from '../hooks/units';
import Button from '@repo/ui/components/Button';
import Input from '@repo/ui/components/Input';

export default function UnitsEntityCard() {
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const { data, isLoading } = useUnits({
    searchQuery,
    page: currentPage,
  });

  return (
    <EntityListCard
      isLoading={isLoading}
      title="Units"
      onSearchQueryChange={setSearchQuery}
      items={data?.units ?? []}
      itemToEntityItem={item => ({
        key: item.unitid,
        title: item.unitcode,
        subtitle: item.unitdescription,
        onClick: () => {},
      })}
      onPageChange={setCurrentPage}
      currentPage={currentPage}
      totalPages={data?.totalPages}
      AddOrUpdateItemFormComponent={AddOrUpdateUnitForm}
    />
  );
}

function AddOrUpdateUnitForm({
  item,
  onCreate,
  onUpdate,
  onDelete,
}: {
  item?: Unit;
  onCreate: () => void;
  onUpdate: () => void;
  onDelete: () => void;
}) {
  const { mutate: createUnit } = useCreateUnit({
    onSuccess: onCreate,
  });

  const { mutate: updateUnit } = useUpdateUnit({
    onSuccess: onUpdate,
  });

  const { mutate: deleteUnit } = useDeleteUnit({
    onSuccess: onDelete,
  });

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const data = Object.fromEntries(formData.entries());
    if (item) {
      updateUnit({
        ...item,
        ...data,
      } as Unit);
    } else {
      createUnit(data as Unit);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 p-4">
      <Input label="Code" name="unitcode" defaultValue={item?.unitcode} maxLength={8} />
      <Input
        isTextarea
        label="Description"
        name="unitdescription"
        defaultValue={item?.unitdescription}
      />
      <div className="space-x-4">
        <Button>{item ? 'Update Unit' : 'Add Unit'}</Button>
        {item && (
          <button
            onClick={() => deleteUnit(item.unitid)}
            type="button"
            className="rounded-md border border-red-500 px-4 py-2 text-sm text-red-500"
          >
            Delete Unit
          </button>
        )}
      </div>
    </form>
  );
}
